export const Data = [
  {
    id: 1,
    question: "What kinds of apartments are listed?",
    answer: "We focus on only ideal and vetted apartments at Rentgage.",
  },
  {
    question: "How do I rent now and pay later?",
    answer:
      "A user(tenant) chooses any of the listed apartments on our mobile app and applies for our flexible payment feature called Renpay. This allows them to move in while they pay their rent in bits.",
  },
  {
    id: 3,
    question: "What is RenPay?",
    answer:
      "Renpay is our flexible payment feature where eligible users who don't want to pay their rents as a yearly lump sum can choose to either pay monthly or quarterly. This attracts a little bit of interest.",
  },
  {
    id: 4,
    question: "What is my BVN used for?",
    answer:
      "For us to verify users' credit worthiness, we require their BVN to do a credit check in order to determine if they qualify for the required credit for their interested apartment.",
  },
  {
    id: 5,
    question: "Is Rentgage only in Lagos?",
    answer:
      "For now, our operations are focused in Lagos. We have plans to expand all over Nigeria and every part of Africa.",
  },
  {
    id: 6,
    question: "Can I use Rentgage for a house I already rented?",
    answer:
      "We are currently only open to apartments listed on our platform. However, we are working on expanding our services to accommodate non-listed apartments in the near future.",
  },
  {
    id: 7,
    question: "Is Rentgage only for new tenants?",
    answer:
      "For now, we only cater to users who want to freshly rent an apartment listed on our platform.",
  },
  {
    id: 8,
    question: "Can I change my payment frequency?",
    answer:
      "Yes you can switch between our various payment options but you cannot switch more than once.",
  },
  {
    id: 9,
    question: "Can I ask for financing on a new house not listed on Rentgage?",
    answer:
      "Our business model does not currently support that. We are looking into incorporating this and we would let you know as soon as we have it sorted.",
  },
  {
    id: 10,
    question: "How can I get my apartment listed?",
    answer:
      "Send us an  email info@rengage.com.ng or give us a call on 07032300911. We would guide you on how to go about it.",
  },
  {
    id: 11,
    question: "Is Rentgage available for non-residential buildings?",
    answer:
      "Yes, we list non-residential buildings too on our platform. The Renpay option is also available for these types of buildings.",
  },
  {
    id: 12,
    question:
      "Can I decide to pay my remaining rent as a lump sum after initial flexible payment?",
    answer:
      "Yes, you can decide to pay up your balance before the due date. Contact our admin, they will guide you on how to follow through.",
  },
  {
    id: 13,
    question: "Is Rentgage a loan company?",
    answer:
      "We are a PropTech company that connects individuals looking to rent apartments with ideal housing units and flexible payment options.",
  },
  {
    id: 14,
    question: "What happens if I default on my payment?",
    answer:
      "Individuals who default on their payment are in breach of our terms of operation and are liable to legal actions which would result in them paying the amount owed with interest and the cost attached to our legal proceedings. Also, this will affect in their credit history and such individual would be rated poorly by credit bureaus, thus they will have less access to loans in Nigeria.",
  },
  {
    id: 15,
    question: "What is the cost of the inspection?",
    answer: "At Rentgage, we have eliminated inspection fees totally",
  },
  {
    id: 16,
    question: "Does Rentgage act as my agent to the landlord?",
    answer:
      "We will get you direct access to the Landlord or his/her official representative for any apartment you rent. We will periodically act as A mediator between you and the landlord should the need arise. However, the Landlord - Tenant relationship is to be maintained directly by both parties and both parties are subject to the signed tenancy agreement.",
  },
  {
    id: 17,
    question: "How do you protect my private information?",
    answer:
      "We abide by global media data privacy standards and uphold your right to privacy. You can read more on our Privacy Policy page. ",
  },
];
